import { useRef, useEffect, useCallback } from 'react';

export const useResizablePane = (
  containerRef,
  variableName = '--global-search-right-width',
  minWidth = 320
) => {
  const isResizingRef = useRef(false);

  const handleResizeMouseDown = useCallback(() => {
    isResizingRef.current = true;
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizingRef.current) return;
      if (!containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const leftWidth = e.clientX - containerRect.left;
      const nextRightWidth = containerWidth - leftWidth;

      const maxWidth = Math.max(minWidth, containerWidth - minWidth);
      const clampedRightWidth = Math.min(
        Math.max(nextRightWidth, minWidth),
        maxWidth
      );

      containerRef.current.style.setProperty(
        variableName,
        `${clampedRightWidth}px`
      );
    };

    const handleMouseUp = () => {
      isResizingRef.current = false;
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [containerRef, variableName, minWidth]);

  return { handleResizeMouseDown };
};
